<template>
  <div class="faq-travelers-page">
    <MobileMenu
      v-if="isTablet"
      :menu="TRAVELERS_MENU_ITEMS"
      :title="title"
      :route-start="staticPath"
      active-item-slug=""
    />
    <div
      v-else
      class="faq-travelers-page__menu-block"
    >
      <Menu />
    </div>
    <main class="faq-travelers-page__content-block">
      <Article
        v-if="faqRubric"
        :rubric="faqRubric"
        class="article-block"
      />
      <div class="faq-travelers-page__additional-block">
        <div class="faq-travelers-page__additional-block-title">Остались вопросы?</div>
        <UiButton
          href="mailto:support@tripster.ru?subject=Вопрос со страницы FAQ"
          text="Напишите в поддержку"
          class="faq-travelers-page__additional-block-button"
          @click="trackSupportButtonClick"
        />
      </div>
    </main>
  </div>
  <SubscriptionBlock :analytics-api-url="VITE_RUNTIME_SOGU_SERVICE_URL" />
</template>

<script setup lang="ts">
  import { useTravelersStore } from '@/entities/travelers/store/useTravelersStore';
  import { useScreenSize } from '@/shared/lib/useScreenSize';
  import { useStaticBasePath } from '@/shared/lib/useStaticBasePath';
  import { useTravelersSoguAnalytics } from '@/shared/lib/useTravelersSoguAnalytics';
  import Menu from '@/pages/travelers/Menu.vue';
  import { TRAVELERS_MENU_ITEMS } from '@/pages/travelers/menuItems';
  import MobileMenu from '@/shared/ui/MobileMenu.vue';
  import Article from '@/widgets/Article.vue';
  import { SubscriptionBlock } from '@experience/subscription-block-package';
  import { UiButton } from '@experience/core-button-ui';
  import { useRuntimeConfig } from 'virtual:runtime-config';
  import { useUserStore } from '@/entities/user';
  import { useHead } from '@unhead/vue';

  const title = 'Помощь путешественникам';

  useHead({
    title: `${title} — Tripster`,
  });

  const travelersStore = useTravelersStore();
  const { faqRubric } = storeToRefs(travelersStore);

  const { VITE_RUNTIME_SOGU_SERVICE_URL } = useRuntimeConfig<false>();
  const { trackSupportButtonClick } = useTravelersSoguAnalytics();
  const { isTablet } = useScreenSize();
  const staticPath = useStaticBasePath();

  const userStore = useUserStore();
  userStore.getUser();

  if (!faqRubric.value) {
    travelersStore.getTravelersQuestions();
  }
</script>

<style lang="scss" scoped>
  .faq-travelers-page {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    gap: var(--alias-space-16);
    padding: 0 var(--alias-space-20);

    @include adaptivity.tablet {
      display: flex;
      flex-direction: column;
      gap: 0;
    }
  }

  .faq-travelers-page__menu-block {
    grid-column: 1 / span 3;
    width: 280px;
    margin-top: var(--alias-space-56);

    @include adaptivity.tablet {
      display: none;
    }
  }

  .faq-travelers-page__content-block {
    grid-column: 5 / span 8;
  }

  .article-block {
    width: 100%;
  }

  .faq-travelers-page__additional-block {
    display: flex;
    flex-direction: column;
    gap: var(--alias-space-16);
    margin-top: var(--alias-space-48);
    padding-bottom: var(--alias-space-32);

    @include adaptivity.tablet {
      padding-bottom: var(--alias-space-24);
      margin-top: var(--alias-space-40);
    }
  }

  .faq-travelers-page__additional-block-title {
    @include typography.base-800-750-extra;

    @include adaptivity.tablet {
      @include typography.base-700-500-extra;
    }
  }

  .faq-travelers-page__additional-block-button {
    width: fit-content;
  }
</style>
